/**
 * @generated SignedSource<<951e8cafd8f493188c645273ddd5b806>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetTableInput = {
  dataSource: string;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAIntegrationTableMutation$variables = {
  input: CreateWidgetTableInput;
  storecastId: string;
};
export type WAIntegrationTableMutation$data = {
  readonly dashboard: {
    readonly createWidgetTable: {
      readonly id: string;
    };
  };
};
export type WAIntegrationTableMutation = {
  response: WAIntegrationTableMutation$data;
  variables: WAIntegrationTableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTable",
        "kind": "LinkedField",
        "name": "createWidgetTable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationTableMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationTableMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "06f86da1c092034d1883b25679aa8851",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationTableMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationTableMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTableInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTable(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb527c00e1749977ae0884c7aedcfdf6";

export default node;
